import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../utils/sagas";
import {useRecaptcha} from "../modals/recaptcha";
import {apiPost} from "./client";

export const useSignUp = (feedbackCh) => {
    const recaptcha = useRecaptcha();
    return useSagaCallback(feedbackCh, useCallback(function* (data) {
        data["captcha-response"] = yield call(recaptcha);
        return yield call(apiPost, `/api/v2/user/create`, data);
    }, [recaptcha]));
};
